module.exports = __webpack_public_path__ + "media/src/assets/Images/Direction-e447f87c9c8adf3d2111b7b47a864ae1.svg";